import Block from 'components/Block'
import ContentBox from 'components/ContentBox'
import TextBody from 'components/TextBody'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import TextTitleCompressedHeavyUpperCase from 'components/TextTitleCompressedHeavyUpperCase'
import TextTitleCompressedLight from 'components/TextTitleCompressedLight'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { STYLES_FONT_SIZE } from 'modules/styles/constants/index.cjs'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { useTheme } from 'modules/styles/index.js'

const messages = defineMessages({
  title: {
    id: 'CheckExerciseFormHowItWorks.title',
    defaultMessage: 'How It Works'
  },
  stepIndex: {
    id: 'CheckExerciseFormHowItWorks.stepIndex',
    defaultMessage: 'Step {index}'
  },
  recordYourSet: {
    id: 'CheckExerciseFormHowItWorks.recordYourSet',
    defaultMessage: 'Record Your Set'
  },
  recordYourSetDescription: {
    id: 'CheckExerciseFormHowItWorks.recordYourSetDescription',
    defaultMessage: 'Start your workout and record yourself performing your exercise. Our AI analyzes your movement in real-time.'
  },
  getInstantFeedback: {
    id: 'CheckExerciseFormHowItWorks.getInstantFeedback',
    defaultMessage: 'Get Instant Feedback'
  },
  getInstantFeedbackDescription: {
    id: 'CheckExerciseFormHowItWorks.getInstantFeedbackDescription',
    defaultMessage: 'Receive immediate AI-powered analysis on your form, depth, range of motion, and technique.'
  },
  improveAndProgress: {
    id: 'CheckExerciseFormHowItWorks.improveAndProgress',
    defaultMessage: 'Improve & Progress'
  },
  improveAndProgressDescription: {
    id: 'CheckExerciseFormHowItWorks.improveAndProgressDescription',
    defaultMessage: 'Apply the corrections, track your improvements over time, and lift with confidence knowing your form is perfect.'
  }
})

const STEPS = [
  {
    titleMessage: messages.recordYourSet,
    descriptionMessage: messages.recordYourSetDescription
  },
  {
    titleMessage: messages.getInstantFeedback,
    descriptionMessage: messages.getInstantFeedbackDescription
  },
  {
    titleMessage: messages.improveAndProgress,
    descriptionMessage: messages.improveAndProgressDescription
  }
]

export function CheckExerciseFormHowItWorks () {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const intl = useIntl()
  const theme = useTheme()

  return (
    <Block
      bgc='black'
      style={{
        color: 'white',
        textAlign: 'center'
      }}
    >
      <View
        centered
        style={{
          maxWidth: theme.maxWidth.desktopCompact
        }}
      >
        <View
          mb={4}
        >
          <TextTitleCompressedHeavy>
            {formatMessageIntlUtil(intl, messages.title)}
          </TextTitleCompressedHeavy>
        </View>
        <View
          row={!isSmallScreen}
          centered
        >
          {
            STEPS.map((step, index) => {
              const {
                titleMessage,
                descriptionMessage
              } = step
              return (
                <ContentBox
                  key={index}
                  f
                  mt={isSmallScreen}
                  bgc={null}
                >
                  <TextTitleCompressedLight
                    style={{
                      color: 'white'
                    }}
                  >
                    {formatMessageIntlUtil(intl, messages.stepIndex, { index: index + 1 })}
                  </TextTitleCompressedLight>
                  <TextTitleCompressedHeavyUpperCase
                    mt
                    style={{
                      fontSize: STYLES_FONT_SIZE.HEADING_SMALL
                    }}
                  >
                    {formatMessageIntlUtil(intl, titleMessage)}
                  </TextTitleCompressedHeavyUpperCase>
                  <View mt>
                    <TextBody mt>
                      {formatMessageIntlUtil(intl, descriptionMessage)}
                    </TextBody>
                  </View>
                </ContentBox>
              )
            })
          }
        </View>
      </View>
    </Block>
  )
}
